"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledLabeledCheckbox = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// External
var StyledLabeledCheckbox = _styledComponents.default.div.withConfig({
  displayName: "LabeledCheckboxstyles__StyledLabeledCheckbox",
  componentId: "ttw7ro-0"
})([".c-labeled-checkbox-wrapper{cursor:pointer;display:flex;font-size:1.5rem;padding:", " 0;position:relative;user-select:none;input{position:absolute;opacity:0;cursor:pointer;}input ~ .unchecked{display:inline-block;}input:checked ~ .unchecked{display:none;}input ~ .checked{display:none;}input:checked ~ .checked{display:inline-block;}}.c-labeled-checkbox-label{font-size:1rem;padding:0 .625rem;}.c-labeled-checkbox-error-container{margin-bottom:", ";min-height:2rem;}.c-labeled-checkbox-error-message{color:", ";margin:0;}"], function (props) {
  return props.theme.standardPadding;
}, function (props) {
  return props.theme.standardPadding;
}, function (props) {
  return props.theme.c_foreground_danger;
});

exports.StyledLabeledCheckbox = StyledLabeledCheckbox;